module.exports = __webpack_public_path__ + "static/img/Empire Related logo s.c34de57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Empire Related logo s.jpg
// module id = 589
// module chunks = 4